import e from"react";import{ExpandMoreIcon as s}from"./styles.js";const t=({className:t})=>e.createElement(s,{className:t});export{t as SelectIcon};
//# sourceMappingURL=SelectIcon.js.map
